import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getAvailableClientServiceTypes, getOptionsByData} from "../../../../_helpers/commonFunctions";
import {fetchAdvancedTypesSales} from "../../../../_apis/api";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";
import {dclStatusOptions, providedServiceCategoryOptions, transmissionFailureOptions} from "./dclStatusOptions";
import {vehicleCategoryOptions} from "../../../../_data/mydata/vehicleCategoryOptions";
import {useTranslation} from "../../../../hooks/useTranslation";

const SearchDcl = () => {
    const {t} = useTranslation();
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const documentTypesOptions = getOptionsByData(SETTINGS.settings.advancedTypesSales, "_id", "name");
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const [installationOptions, setInstallationOptions] = useState([]);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const clientServiceTypes = getAvailableClientServiceTypes(permissionsData);

    useEffect(() => {
        dispatch(fetchAdvancedTypesSales({company: company.id}))
    }, []);

    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            companyInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.type + " " + inst.address + " " + inst.city });
            })
            setInstallationOptions(options);
        }
    }, []);

    const ssColumns = [
        {
            name: t('SalesSearch.table.date'),
            field: "creationDateTime",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Κωδικός MyData",
            field: "dclId",
            hiddenColumn: true,
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Κατηγορία Ψηφιακού Πελατολογίου",
            field: "clientServiceType",
            editable: false,
            hiddenColumn: true,
            inputType: {
                type: 'dropdownOption',
                options: clientServiceTypes
            }
        },
        {
            name: "Πινακίδα Οχήματος",
            field: "vehicleRegistrationNumber",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Όχημα",
            field: "vehicleFactory",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.client'),
            field: "clientName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesSearch.table.documentType'),
            field: "documentTypeName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },

        {
            name: "Κατηγορία Υπηρεσίας",
            field: "serviceCategory",
            width: "120px",
            editable: false,
            inputType: {
                type: 'dropdownOption',
                options: [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής"}]
            }
        },
        {
            name: "Παρεχόμενη Υπηρεσία",
            field: "providedServiceCategory",
            editable: false,
            inputType: {
                type: 'dropdownOption',
                options: providedServiceCategoryOptions
            }
        },

        {
            name: "Συμφωνηθέν Ποσό",
            field: "amount",
            editable: true,
            disabled: true,
            width: "100px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: "Κατάσταση",
            field: "status",
            width: "130px",
            editable: false,
            inputType: {
                type: 'dropdownOption',
                options: dclStatusOptions
            }
        },
        {
            name: "Σημειώσεις",
            field: "notes",
            hiddenColumn: true,
            editable: false,
            inputType: {
                type: 'text',
            },
        }
    ]

    const searchSaleFilters = {
        filters: [
            {
                name: "clientName",
                label: t('SalesSearch.table2.clientNameFrom'),
                type: "input",
            },
            {
                name: "vehicleRegistrationNumber",
                label: "Πινακίδα/Μοντέλο Οχήματος",
                type: "input",
            },
            {
                name: "vehicleCategory",
                label: "Κατηγορία Οχήματος",
                type: "multiselect",
                options: vehicleCategoryOptions
            },
            {
                name: "documentType",
                label: t('SalesSearch.table2.documentType'),
                type: "multiselect",
                options: documentTypesOptions
            },
            {
                name: "installation",
                label: "Εγκατάσταση",
                type: "dropdown",
                options: installationOptions
            },
            {
                name: "clientServiceType",
                label: "Τύπος Ψηφιακού Πελατολογίου",
                type: "dropdown",
                options: clientServiceTypes
            },
            {
                name: "serviceCategory",
                label: "Κατηγορία Υπηρεσίας",
                type: "multiselect",
                options: [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής"}]
            },
            {
                name: "providedServiceCategory",
                label: "Παρεχόμενη Υπηρεσία",
                type: "multiselect",
                options: providedServiceCategoryOptions
            },
            {
                name: "amount_from",
                label: "Συμφωνηθέν Ποσό Από:",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "amount_to",
                label: "Συμφωνηθέν Ποσό Μέχρι:",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "status",
                label: "Κατάσταση",
                type: "multiselect",
                options: dclStatusOptions,
                mdWidth: 2,
            },
            {
                name: "notes",
                label: "Σημειώσεις Εγγραφής",
                type: "input",
            },
            {
                name: "transmissionFailure",
                label: "Αδυναμία Σύνδεσης",
                type: "dropdown",
                options: transmissionFailureOptions
            },
        ]
    };
    const [tableColumns, setTableColumns] = useState(ssColumns.slice());

    // It will hide or show the table columns for search table.
    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
            <SearchTable
                tableName="Dcl Search"
                key={"Dcl Search"}
                hideYearFilter={false}
                allowPagination={true}
                allowSelectionCheckbox={false}
                allowToggleColumns={true}
                toggleColumns={handleColumnShowHide}
                allowPrintResults={true}
                dataEndpoint={"/dcl/search-dcl"}
                exportFileName={"Εγγραφές Ψηφ. Πελ."}
                columns={tableColumns}
                data={[]}
                filtersConfig={searchSaleFilters}
            />
    )
}

export default SearchDcl;
